import React from 'react';
import type { ISnapIcon } from '../icons-mapper';

export const ChevronRightSolid = (props: ISnapIcon) => {
  const { size, title, color = 'currentColor' } = props;
  return (
    <svg
      height={size}
      width={size}
      viewBox='0 0 20 20'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.35178 15.6482C6.12654 15.4229 6 15.1173 6 14.7988C6 14.4802 6.12654 14.1746 6.35178 13.9493L10.3083 9.99275L6.35178 6.0362C6.13292 5.80959 6.01182 5.50609 6.01455 5.19106C6.01729 4.87603 6.14365 4.57468 6.36642 4.35191C6.58919 4.12914 6.89054 4.00278 7.20557 4.00005C7.5206 3.99731 7.8241 4.11841 8.05071 4.33728L12.8567 9.14328C13.082 9.3686 13.2085 9.67415 13.2085 9.99275C13.2085 10.3113 13.082 10.6169 12.8567 10.8422L8.05071 15.6482C7.82539 15.8735 7.51984 16 7.20125 16C6.88265 16 6.5771 15.8735 6.35178 15.6482Z'
      />
    </svg>
  );
};
